<template>
  <div class="w-full flexing absolute safe-area-x header">
    <div class="triangle triangle-left white cursor-pointer" @click="toggleShowPuzzleBar" />
    <div class="flexing text-white text-36">
      <div v-for="(param, index) in getGalleryParams" :key="index" class="flexing">
        <app-main-icon class="puzzle-icon" :icon-name="param.parameter_name" :icon-size="52" />
        <animated-number :param="param" class="puzzle-pieces-count flexing" />
      </div>
      <div class="triangle white cursor-pointer pointer-events-auto" @click="toggleShowPuzzleBar" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { useResponseTaskStore } from '@/store/pinia/responseTaskStore'
import AnimatedNumber from '../AnimatedNumber.vue'

export default defineComponent({
  name: 'GalleryPuzzleStatus',
  components: { AnimatedNumber },
  emits: ['toggleShowPuzzleBar'],
  
  computed: {
    ...mapState(useResponseTaskStore, ['getGalleryParams']),
  },

  methods: {
    toggleShowPuzzleBar(): void {
      this.$emit('toggleShowPuzzleBar')
    },
  },
})
</script>

<style lang="scss" scoped>
@import '@/assets/styles/components/header.scss';

.puzzle-icon {
  margin-right: -1.5rem;
  z-index: 1;
}
.puzzle-pieces-count {
  width: 13.125rem;
  height: 2.5625rem;
  @if $isWsm {
    background-color: #010b1c;
  }
  @if $isSsm {
    background-color: #1f2336;
  }
}

.triangle {
  margin: 0 2.875rem;
}
</style>
